// External Dependencies
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import clsx from 'clsx';
import styled from 'styled-components';

// Local Typings
interface Props {
  context: string;
  navigateTo?: string;
  onClickButton?: () => void;
  rootClassName?: string;
}

// Local Variables
const StyledButton = styled(Button)(({ theme }) => ({
  '.back-icon': {
    [theme.breakpoints.down('md')]: {
      fontSize: theme.spacing(2),
    },
    marginRight: theme.spacing(1),
  },
  [theme.breakpoints.down('md')]: {
    fontSize: theme.spacing(1.5),
    marginBottom: theme.spacing(1),
  },
  backgroundColor: theme.palette.common.white,
}));

// Component Definition
const BackToButton = ({
  context,
  navigateTo,
  onClickButton,
  rootClassName,
}: Props): JSX.Element => {
  const navigate = useNavigate();

  const handleClick = useCallback(() => {
    if (onClickButton) {
      onClickButton();
    } else if (navigateTo) {
      navigate(navigateTo);
    }
  }, [navigate, navigateTo, onClickButton]);

  return (
    <StyledButton
      className={clsx('back-button', rootClassName)}
      color="primary"
      onClick={handleClick}
      onKeyPress={handleClick}
      size="small"
      startIcon={(
        <ArrowBackIcon
          className="back-icon"
          fontSize="small"
        />
      )}
      variant="outlined"
    >
      Back to {context}
    </StyledButton>
  );
};

export default BackToButton;
